var notification = {
    totalNotification : 0,
    showNotificaciones: function () { 
        if(auth.id.length = 0) {
            return false;
        }
        $.ajax({
            url: main.hostClient + 'api-client/notification?psId=' + auth.id,
            type: 'GET',
            dataType: "json",
            headers: {
                "Authorization": checkout.token,
                "Content-Type": "application/json"
            },
            success : function(response) {
                if (response.success) {
                    var notificacionString = '';
                    if(response.data.total>0) {
                        var totals = response.data.total > 99? '+99' : response.data.total;
                        $('#idNotificationContent').html('<i class="fas fa-bell"></i><span>' + totals + '</span>');
                        //$('#idNotificationContentPendientes').html(totals); 
                    } else {
                        $('#idNotificationContent').html('<i class="fas fa-bell"></i>');
                        //$('#idNotificationContentPendientes').html(''); 
                    }
                    
                    //obj.params.totalNotification = response.data.total
                    $.each(response.data.notificaciones, function (key, value) {
                        if(value.status==0) {
                            className = 'not-unread';
                             notificacionString += '<li>'+
                                '<a class="not-unread" data-id="' + value.id + '" data-url="' + value.url + '" data-type="'+value.type+'" href="javascript:void(0)">'+
                                    '<div class="clear-fix item-not">'+
                                        ''+aula.timeToDescription(value.fecha)+''+
                                        '<p><strong>'+ value.user.name.replace(/\\('|&quot;)/g, '$1') + '</strong>, '+value.titulo.replace(/\\('|&quot;)/g, '$1')+'</p>'+
                                    '</div>'+
                                '</a>'+
                            '</li>';
                        } else {
                            notificacionString += '<li>'+
                                '<a class="not-read" data-id="'+value.id+'" data-type="'+value.type+'" href="'+value.url+'?ref=notify">'+
                                    '<div class="clear-fix item-not">'+
                                        ''+aula.timeToDescription(value.fecha)+''+
                                        '<p><strong>'+ value.user.name.replace(/\\('|&quot;)/g, '$1') + '</strong>, '+value.titulo.replace(/\\('|&quot;)/g, '$1')+'</p>'+
                                    '</div>'+
                                '</a>'+
                            '</li>';
                        }

                        /*
                        notificacionString += '<li>'+
                            '<a class="'+className+'" data-id="'+value.id+'" data-type="'+value.type+'" href="'+value.url+'?ref=notify">'+
                                '<div class="clear-fix item-not">'+
                                    '<span>'+aula.timeToDescription(value.fecha)+'</span>'+
                                    '<p><strong>'+ value.user.name.replace(/\\('|&quot;)/g, '$1') + '</strong>, '+value.titulo.replace(/\\('|&quot;)/g, '$1')+'</p>'+
                                '</div>'+
                            '</a>'+
                        '</li>';
                        */
                    });
                    $('#idNotificationMessages').html(notificacionString);
                    notification.totalNotification = response.data.total;
                    notification.readNotification();
                }
            }
        });
    },
    updateNotification: function () { 
    	$('#idNotificationContent').click(function (e) {
			if(notification.totalNotification>0){
				$.ajax({
		            url: main.hostClient + 'api-client/notification/' + auth.id,
		            type: 'PUT',
                    dataType: "json",
                    headers: {
                        "Authorization": checkout.token,
                        "Content-Type": "application/json"
                    },
                    success : function(response) {
                        if (response.success) {
                            $('#idNotificationContent').html('<i class="fas fa-bell"></i>');
                            //$('#idNotificationContentPendientes').html('');
                        }
                    }
		        });
			}
        });
    },
    readNotification: function () { 
    	$('.not-unread').click(function (e) {
    		var id = $(this).attr('data-id');
    		var url = $(this).attr('data-url');
			$.ajax({
	            url: main.hostClient + 'api-client/notification/' + id,
	            data:{},
	            type: 'PUT',
                dataType: "json",
                headers: {
                    "Authorization": checkout.token,
                    "Content-Type": "application/json"
                },
                success : function(response) {
                    if (response.success) {
                        window.location.href = url;
                    }
                }
	        });
        });
    }
}
